import contact from 'src/i18n/en/validations/contact';
import login from 'src/i18n/en/validations/login';
import invoice from 'src/i18n/en/validations/invoice';
import creditcard from 'src/i18n/en/validations/creditcard';
import organisation from 'src/i18n/en/validations/organisation';
import fundraising from 'src/i18n/en/validations/fundraising';
import ticket from 'src/i18n/en/validations/ticket';
import notifications from 'src/i18n/en/validations/notifications';

const validations = {
  contact,
  creditcard,
  fundraising,
  invoice,
  login,
  notifications,
  organisation,
  ticket,
};

export default validations;
